import { Component, OnDestroy, OnInit } from '@angular/core';
import {
  UntypedFormControl,
  UntypedFormGroup,
  Validators,
} from '@angular/forms';
import {
  DateAdapter,
  MAT_DATE_FORMATS,
  MAT_DATE_LOCALE,
} from '@angular/material/core';
import { MatDialogRef } from '@angular/material/dialog';
import { GlobalConstants } from '@globalConstants';
import { IFormErrors } from '@interfaces/IFormsErrors';
import { IAppState } from '@myStore/app.state';
import { ClearTransferToESDP } from '@myStore/groups-changes/groups-changes.actions';
import {
  selectChangesGroupFailure,
  selectChangesGroupLoading,
} from '@myStore/groups-changes/groups-changes.selector';
import { select, Store } from '@ngrx/store';
import { UIThemeService } from '@services/UITheme/UITheme.service';
import { CustomDateAdapter } from '@shared/adapter/date.adapter';
import { FormDialogComponent } from '@shared/components/UI/form-dialog/form-dialog.component';
import { MyErrorStateMatcher } from '@validators/matcher';
import * as moment from 'moment';
import { Subject } from 'rxjs';
import { takeUntil } from 'rxjs/operators';

@Component({
  selector: 'app-transfer-group-to-esdp-form',
  templateUrl: './transfer-group-to-esdp-form.component.html',
  styleUrls: ['./transfer-group-to-esdp-form.component.sass'],
  providers: [
    {
      provide: DateAdapter,
      useClass: CustomDateAdapter,
      deps: [MAT_DATE_LOCALE],
    },
    {
      provide: MAT_DATE_FORMATS,
      useValue: GlobalConstants.DEFAULT_DATEPICKER_FORMAT,
    },
  ],
})
export class TransferGroupToEsdpFormComponent implements OnInit, OnDestroy {
  public loading$ = this._store.pipe(select(selectChangesGroupLoading));
  public errors$: IFormErrors | null = null;
  public matcher = new MyErrorStateMatcher();
  public days = {
    '1': 'Понедельник',
    '2': 'Вторник',
    '3': 'Среда',
    '4': 'Четверг',
    '5': 'Пятница',
    '6': 'Суббота',
  };
  public form = new UntypedFormGroup({
    lesson_days: new UntypedFormControl('', [Validators.required]),
    period_start_date: new UntypedFormControl(GlobalConstants.dateFormat, [
      Validators.required,
    ]),
    is_esdp: new UntypedFormControl(true),
  });
  private destroy$: Subject<boolean> = new Subject<boolean>();

  constructor(
    private _store: Store<IAppState>,
    public dialogRef: MatDialogRef<FormDialogComponent>,
    public UIThemeService: UIThemeService
  ) {}

  ngOnInit(): void {
    this._store
      .pipe(select(selectChangesGroupFailure), takeUntil(this.destroy$))
      .subscribe(errors => {
        this.errors$ = errors;
        this.setControlErrors(errors);
      });
  }

  onSubmit() {
    const data = {
      ...this.form.value,
      period_start_date: moment(
        this.form.controls['period_start_date'].value
      ).format('YYYY-MM-DD'),
    };

    if (this.dialogRef.componentInstance.data.submit && !this.form.invalid) {
      this.dialogRef.componentInstance.data.submit(data);
    }
  }

  get lesson_days() {
    return this.form.get('lesson_days');
  }

  get period_start_date() {
    return this.form.get('period_start_date');
  }

  setControlErrors(errors: IFormErrors | null): void {
    if (errors) {
      Object.keys(errors).forEach(key => {
        if (this.form.controls[key] && key !== 'is_esdp') {
          this.form.controls[key].setErrors({
            errors: errors[key],
          });
        }
      });
    }
  }

  onCancel() {
    this.dialogRef.close();
  }

  ngOnDestroy() {
    this._store.dispatch(new ClearTransferToESDP());

    this.destroy$.next(true);
    this.destroy$.unsubscribe();
  }
}
